<template>
  <div id="home">
    <div class="fadeIn">
      <login></login>
    </div>
  </div>
</template>

<script>
import Login from '../components/login'

export default {
    components: {
        Login,
    },
}
</script>

<style lang="scss">
#home {
    display: flex;
    height: 100vh;
    width: 100vw;
    justify-content: space-evenly;
    background-color: whitesmoke;
    & > div {
        height: min-content;
        width: 300px;
        align-self: center;
        margin: 10px;
        border: 1px solid gainsboro;
        overflow-x: visible;
        background-color: white;
        padding: 3px;
        border-radius: 5px;
        box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.15);
    }
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.fadeIn {
    animation-iteration-count: 1;
    animation-name: fadeIn;
    animation-duration: 2s;
}
</style>
